<template>
  <div ref="cardDom" class="page-container">
    <!-- 图表标题 -->
    <div class="top-container">
      <div class="title">{{ props.title }}</div>
    </div>
    <!-- 图表 -->
    <div ref="chartDom" class="chart-container">
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, defineProps } from "vue";
import dayjs from "dayjs";
import * as echarts from 'echarts';
import { getChartOption } from "./linesChartOptions.js"

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  chartData: {
    type: Array,
    default: [],
  },
  timeRange: {
    type: Array,
    default: [],
  },
});


const cardDom = ref(null);
const chartDom = ref(null);
let chartObj = null; // 引用echarts实例对象

onMounted(() => {
  /** 初始化图表，执行图表渲染 */
  chartObj = echarts.init(chartDom.value);
  refreshChart(props.chartData, props.timeRange);

  /** 创建 ResizeObserver 实例 >>> 监听cardDom尺寸的变化 >>> 重置图表尺寸 */
  const resizeObserver = new ResizeObserver(entries => { chartObj.resize(); });
  resizeObserver.observe(cardDom.value);
})

/** 刷新图表 */
watch(() => props.chartData, nv => {
  refreshChart(props.chartData, props.timeRange);
})

watch(() => props.timeRange, nv => {
  refreshChart(props.chartData, props.timeRange);
})


/** 刷新图表 */
function refreshChart(chartData, timeRange = props.timeRange) {
  if (Array.isArray(timeRange) && timeRange.length == 2) {
    const startTime = dayjs(timeRange[0]).format('YYYY-MM-DD 00:00:00');
    const endTime = dayjs(timeRange[1]).format('YYYY-MM-DD 23:59:59');
    const options = getChartOption(chartData, startTime, endTime);
    chartObj.clear();
    chartObj.setOption(options);
  } else {
    chartObj.clear();
  }
}


/** 监听浏览器尺寸变化，重置图表尺寸 */
window.addEventListener('resize', () => {
  if (chartObj) {
    chartObj.resize();
  }
})

</script>
<style lang="scss" scoped>
.page-container {
  --top-container-h: 32px;
  font-family: PingFang-SC, PingFang-SC;
  height: 100%;
  width: 100%;
  min-width: 0;
  padding: 10px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  // gap: 6px;

  .top-container {
    width: 100%;
    height: var(--top-container-h);
    display: flex;

    .title {
      color: #2e2e2e;
      font-size: 14px;
    }

  }

  .chart-container {
    box-sizing: border-box;
    width: 100%;
    height: calc(100% - var(--top-container-h));
    flex: 1;
    min-width: 0;
    min-height: 0;
    overflow: hidden;
  }

  // 设置图表tooltip的样式
  ::v-deep .chart-tooltip {
    padding: 12px 16px !important;
    border-radius: 8px !important;
    background: rgba(255, 255, 255, 0.90) !important;
    backdrop-filter: blur(4px);
    border: none !important;
  }

  ::v-deep .chart-tooltip__time {
    margin-bottom: 8px;
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #000000;
  }

  ::v-deep .chart-tooltip__items-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  ::v-deep .chart-tooltip__series {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    line-height: 1.5;
  }

  ::v-deep .chart-tooltip__series-name,
  ::v-deep .chart-tooltip__value {
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #000000;
  }

  ::v-deep .chart-tooltip__point {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
